import * as React from 'react';
import { Layout } from '../Layout';
import { VerticalSlider } from '../VerticalSlider';
import * as styles from './News.css';

interface INewsProps {
  title: React.ReactNode;
  news: React.ReactNode;
}

export function News({ title, news }: INewsProps) {
  return (
    <section id="news" className={styles['news']}>
      <Layout>
        <div className={styles['news__title']}>{title}</div>

        <VerticalSlider>{React.Children.map(news, item => item)}</VerticalSlider>
      </Layout>
    </section>
  );
}
